import React, { FC, ReactNode, CSSProperties } from 'react';
import { Button as BTButton, ButtonProps } from 'reactstrap';

interface ButtonType extends ButtonProps {
    loading?: boolean;
    children: ReactNode;
    fullWidth?: boolean;
    icon?: string | null;
    soft?: boolean;
    style?: CSSProperties;
}
const Button: FC<ButtonType> = ({ loading, children, disabled, fullWidth = false, className, icon = null, soft, style = {}, ...props }) => {

    const mergedStyle: CSSProperties = {
        width: fullWidth ? '100%' : 'auto',
        ...style, // Allows overriding width or adding more styles
    };

    return (
        <BTButton {...props} disabled={loading || disabled} style={mergedStyle} className={`${className} ${icon ? 'btn-label' : ''} ${soft ? `btn-soft-${props.color}` : ''}`}>
            {icon ?
                (loading ?
                    <span className='label-icon'><i className="fa-solid fa-spinner fa-spin"></i></span>
                    :
                    <span className="align-middle material-symbols-outlined fw-light fs-4 label-icon">{icon}</span>)
                : null
            }
            {(loading && !icon) ? <span><i className="fa-solid fa-spinner fa-spin"></i>&nbsp;  </span> : null}
            {children}
        </BTButton>
    )
}

export default Button;